"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
/**
 * Open header menu
 */
var MainMenu = /** @class */ (function (_super) {
    __extends(MainMenu, _super);
    function MainMenu() {
        var _this = _super.call(this, constants_1.DATA_HEADER) || this;
        if (!_this.getElement())
            return _this;
        MainMenu.menuToggleBtn = _this.getElement().querySelector("[".concat(constants_1.DATA_MAIN_MOBILE_MENU_TOGGLER, "]"));
        MainMenu.menuModalMobile = _this.getElement().querySelector("[".concat(constants_1.DATA_MAIN_MOBILE_MODAL, "]"));
        MainMenu.menuBurgerMobile = _this.getElement().querySelector("[".concat(constants_1.DATA_MOBILE_MENU_BURGER, "]"));
        MainMenu.menuOverlay = document.querySelector("[".concat(constants_1.DATA_MAIN_MENU_OVERLAY, "]"));
        _this.initEventListeners();
        return _this;
    }
    /**
     * Init listeners
     * @private
     */
    MainMenu.prototype.initEventListeners = function () {
        window.addEventListener('keyup', function (e) {
            if (e.code == 'Escape')
                MainMenu.closeMenu();
        });
        MainMenu.menuToggleBtn.addEventListener('click', function () {
            MainMenu.toggleMenu();
        });
        MainMenu.menuOverlay.addEventListener('click', function () {
            MainMenu.closeMenu();
        });
    };
    MainMenu.toggleMenu = function () {
        this.menuModalMobile.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
        this.menuBurgerMobile.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
        this.menuOverlay.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
    };
    MainMenu.closeMenu = function () {
        this.menuModalMobile.classList.remove(constantsClasses_1.CLASS_ACTIVE);
        this.menuBurgerMobile.classList.remove(constantsClasses_1.CLASS_ACTIVE);
        this.menuOverlay.classList.remove(constantsClasses_1.CLASS_ACTIVE);
    };
    return MainMenu;
}(AbstractComponent_1.default));
exports.default = MainMenu;
